import React, { useState } from "react";
import styles from "./NormalChart.module.css";
import {
	primaryTextColor,
	secondaryTextColor,
	fw400,
	titleL,
} from "../../../../Global.module.css";
import ChartSelector from "../../ChartSelector/ChartSelector";
import Modal from "../../../reusable/Modal/Modal";
import ChartBlock from "../../LayoutBlocks/ChartBlock/ChartBlock";
import ChartEditor from "../../ChartEditor/ChartEditor";
import Edit from "../../../../assets/edit.svg";
import { getDemoData } from "../../../../helpers/getDemoData";
import TitleBlock from "../../LayoutBlocks/TitleBlock/TitleBlock";

export default function NormalChart({ id, data, onChange }) {
	const [addChart, setAddChart] = useState(false);
	const [edit, setEdit] = useState(false);

	const onChartSelect = async (chartType) => {
		let data = await getDemoData(chartType);
		onChange({
			...data,
			chartType: chartType,
			chartData: data || [],
			chartConfig: {},
		});
		handleEditor();
	};

	const handleAddChart = () => {
		setAddChart(!addChart);
	};

	const onChartDelete = () => {
		delete data.chartType;
		delete data.chartData;
		delete data.chartConfig;
		onChange({
			...data,
		});
	};

	const onTitleChange = (value) => {
		onChange({
			...data,
			title: value,
		});
	};

	const alignTitle = (alignment) => {
		onChange({
			...data,
			alignTitle: alignment,
		});
	};

	const onChartConfigChange = (chartConfig) => {
		onChange({
			...data,
			chartConfig,
		});
	};

	const onChartDataChange = (chartData) => {
		onChange({
			...data,
			chartData,
		});
	};

	const handleEditor = () => {
		setEdit(!edit);
	};

	return (
		<>
			<div id={id} className={styles.normalChart}>
				<TitleBlock
					title={data.title}
					onChange={onTitleChange}
					alignment={data.alignTitle}
					changeAlignment={alignTitle}
				/>
				{data.chartType ? (
					<div className={styles.chartBlock}>
						<ChartBlock
							chartType={data.chartType}
							chartData={data.chartData}
							chartConfig={data.chartConfig}
							onDelete={onChartDelete}
						/>
						<div className={styles.editBtn} onClick={handleEditor}>
							<img src={Edit} alt="" />
							<p
								className={`${secondaryTextColor} ${fw400} ${titleL}`}
							>
								Edit
							</p>
						</div>
					</div>
				) : (
					<div className={styles.actions}>
						<button
							className={`${styles.btn} ${primaryTextColor} ${fw400} ${titleL}`}
							onClick={handleAddChart}
						>
							Add Chart
						</button>
					</div>
				)}
			</div>
			{edit && data.chartType ? (
				<Modal>
					<ChartEditor
						chartType={data.chartType}
						chartData={data.chartData}
						chartConfig={data.chartConfig}
						onChartConfigChange={onChartConfigChange}
						onChartDataChange={onChartDataChange}
						closeEditor={handleEditor}
					/>
				</Modal>
			) : null}
			{addChart ? (
				<Modal>
					<ChartSelector
						chartSelected={onChartSelect}
						closeSelector={handleAddChart}
					/>
				</Modal>
			) : null}
		</>
	);
}
